import { Stack, Typography, useTheme } from '@mui/material';
import Box from '@mui/system/Box';
import React from 'react';

import { MenuItemEnum } from '@/components/layout/sidebar/sideBarMenu/model/SideBarMenuItems.model.tsx';
import { OcdRouterLink } from '@/components/layout/topBar/components/TopBarMenuItem.comp.tsx';
import { RouteEnum } from '@/models/route/Route.model.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

export const NewsMenuItem: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslationWithPrefix('menu.item');

  const menuItem = MenuItemEnum.NEWS;

  return (
    <Box
      sx={{
        '&:hover': {
          backgroundColor: theme.colors.bgCard3,
          color: theme.colors.textPrimary,
        },
        borderRadius: '16px',
        color: theme.colors.textSecondary,
        cursor: 'pointer',
        transition: 'all 0.2s cubic-bezier(0.4,0,0.2,1)',
      }}
    >
      <OcdRouterLink id={menuItem} route={RouteEnum.NEWS}>
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            borderRadius: '16px',
            gap: 0.5,
            px: 1.5,
            py: 1,
          }}
        >
          <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>{t(menuItem)}</Typography>
        </Stack>
      </OcdRouterLink>
    </Box>
  );
};
